import {Injectable} from '@angular/core';
import {FormArray, FormGroup, ValidatorFn} from '@angular/forms';

/**
 * The FormService simplifies handling FormGroups and FormArrays
 */
@Injectable({
    providedIn: 'root'
})
export class FormService {

    moveFormArrayEntry(form: FormGroup, control: string, currentIndex: number, shift: number): void {
        const formArray = this.getFormArray(form, control);

        let newIndex = currentIndex + shift;
        if (newIndex === -1) {
            newIndex = formArray.length - 1;
        } else if (newIndex === formArray.length) {
            newIndex = 0;
        }

        const currentElement = formArray.at(currentIndex);
        formArray.removeAt(currentIndex);
        formArray.insert(newIndex, currentElement);
    }

    removeFormArrayItem(form: FormGroup, control: string, index: number): void {
        this.getFormArray(form, control).removeAt(index);
    }

    getFormArray(form: FormGroup, control: string): FormArray {
        return form.get(control) as FormArray;
    }

    getFormArrayItem(form: FormGroup, control: string, index: number): FormGroup {
        return this.getFormArray(form, control).at(index) as FormGroup;
    }

    addValidators(form: FormGroup, controls: string[], validators: ValidatorFn | ValidatorFn[]): void {
        controls.forEach(control => {
            form.get(control)?.addValidators(validators);
            form.get(control)?.updateValueAndValidity();
        });
    }

    removeValidators(form: FormGroup, controls: string[], validators: ValidatorFn | ValidatorFn[]): void {
        controls.forEach(control => {
            form.get(control)?.removeValidators(validators);
            form.get(control)?.updateValueAndValidity();
        });
    }
}
